export type GuideNavItem = {
    id: string;
    label: string;
    href?: string;
    subTitle?: string;
    items?: GuideNavItem[];
};

export const GUIDE_NAV_ITEMS: GuideNavItem[] = [
    {
        id: 'principles',
        label: '분양의신 3원칙',
        subTitle: '분양의신 3원칙',
        href: '/guide/principles/index',
        items: [
            {
                id: 'premium-solution',
                label: '프리미엄 콘텐츠 & 성과 중심 광고 솔루션',
                href: '/guide/principles/premium',
                subTitle: '분양의신 3원칙',
            },
            {
                id: 'all-in-one',
                label: '올인원(All-in-One) 대행 시스템',
                href: '/guide/principles/all-in-one',
                subTitle: '분양의신 3원칙',
            },
            {
                id: 'profit-driven',
                label: '고객이 실제로 돈을 벌게 만드는 광고',
                href: '/guide/principles/profit',
                subTitle: '분양의신 3원칙',
            },
        ],
    },
    {id: 'process', label: '광고 운영 프로세스', href: '/guide/process', subTitle: '분양의신 가이드',},
    {
        id: 'creative', label: '콘텐츠 제작', href: '/guide/creative',
        subTitle: '콘텐츠 제작',
        items: [
            {
                id: 'banner',
                label: '배너 & 홈페이지 콘텐츠',
                href: '/guide/content/banner',
                subTitle: '콘텐츠 제작',
            },
            {
                id: 'cf',
                label: '분양의신 CF 배너 시스템',
                href: '/guide/content/cf',
                subTitle: '콘텐츠 제작',
            }
        ],
    },
    {id: 'product', label: '광고 상품 가이드', href: '/guide/product',subTitle: '분양의신 가이드'},
    {id: 'property', label: '물건별 광고 가이드', href: '/guide/property',subTitle: '분양의신 가이드'},
    {id: 'placements', label: '광고 게재 위치', href: '/guide/placements',subTitle: '분양의신 가이드'},
    {id: 'faq', label: '자주 묻는 질문 (FAQ)', href: '/guide/faq',subTitle: '분양의신 가이드'},
    {
        id: 'contact',
        label: '분양의신 1:1 맞춤 컨설팅 받기',
        href: 'https://분양의신.net/contact',
    },
    // {id: 'company', label: '회사소개', href: 'https://분양의신.net/company'},
    // {
    //     id: 'portfolio',
    //     label: '지역별 포트폴리오',
    //     href: 'https://분양의신.net/portfolio',
    // },
    // {
    //     id: 'consultant',
    //     label: '컨설턴트',
    //     href: 'https://분양의신.net/consultant',
    // },
    // {id: 'hightarget', label: '하이타겟', href: 'https://분양의신.net/hightarget'},
    // {id: 'ad-inside', label: '광고인사이드', href: 'https://adperson-inside.com/'},
    // {
    //     id: 'greeting',
    //     label: '그리팅',
    //     href: 'https://adperson.career.greetinghr.com/ko/main',
    // },
];


export const MOBILE_NAV_ITEMS: GuideNavItem[] = [
    {
        id: 'principles',
        label: '분양의신 3원칙',
        subTitle: '분양의신 가이드',
        href: '/guide/principles/index',
    },
    {id: 'process', label: '광고 운영 프로세스', href: '/guide/process', subTitle: '분양의신 가이드',},
    {
        id: 'creative', label: '콘텐츠 제작', href: '/guide/creative',
        subTitle: '분양의신 가이드',
    },
    {id: 'product', label: '광고 상품 가이드', href: '/guide/product',subTitle: '분양의신 가이드'},
    {id: 'property', label: '물건별 광고 가이드', href: '/guide/property',subTitle: '분양의신 가이드'},
    {id: 'placements', label: '광고 게재 위치', href: '/guide/placements',subTitle: '분양의신 가이드'},
    {id: 'faq', label: '자주 묻는 질문 (FAQ)', href: '/guide/faq',subTitle: '분양의신 가이드'},

];
